var _defs, _g, _rect, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpitex(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 77.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .st1 {\r\n        fill: #348fde;\r\n      }\r\n\r\n      .st2 {\r\n        fill: #d1d1d1;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -9.32,
    y1: 9.56,
    x2: 42.06,
    y2: 57.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 21.51,
    cy: 38.62,
    r: 2.85
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 25.51,
    cy: 33.93,
    r: 2.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 21.35,
    cy: 30.94,
    r: 1.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 20.87,
    cy: 46.68,
    r: 1.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 28.98,
    cy: 38.67,
    r: 1.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 29.78,
    cy: 30.17,
    r: 1.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 12.98,
    cy: 29.86,
    r: 1.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 12.82,
    cy: 46.75,
    r: 1.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 29.78,
    cy: 46.91,
    r: 1.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 25.86,
    cy: 49.84,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 32.54,
    cy: 43.21,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 32.54,
    cy: 33.91,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 26.02,
    cy: 27.08,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 16.72,
    cy: 27.16,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 10.02,
    cy: 33.7,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 9.82,
    cy: 43.08,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 16.55,
    cy: 49.58,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 9.14,
    cy: 50.69,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 33.71,
    cy: 50.69,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 33.74,
    cy: 26.25,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 9.29,
    cy: 25.99,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 7.13,
    cy: 30.17,
    r: 0.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 6.26,
    cy: 22.74,
    r: 0.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 4.76,
    cy: 27.19,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 10.57,
    cy: 21.55,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 4.65,
    cy: 49.24,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 10.18,
    cy: 55.13,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 32.3,
    cy: 55.13,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 37.95,
    cy: 49.58,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 38.25,
    cy: 27.54,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 32.54,
    cy: 21.71,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 13.66,
    cy: 24.21,
    r: 0.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 13.5,
    cy: 24.21,
    r: 0.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 6.97,
    cy: 46.43,
    r: 0.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 13.24,
    cy: 52.58,
    r: 0.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 35.55,
    cy: 46.68,
    r: 0.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 29.62,
    cy: 24.21,
    r: 0.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 29.34,
    cy: 53,
    r: 0.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 5.88,
    cy: 53.88,
    r: 0.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 35.55,
    cy: 30.48,
    r: 0.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 36.8,
    cy: 53.88,
    r: 0.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 37.08,
    cy: 23.33,
    r: 0.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 13.24,
    cy: 38.67,
    r: 1.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 16.87,
    cy: 34.13,
    r: 2.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 16.55,
    cy: 42.63,
    r: 2.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 25.51,
    cy: 43.21,
    r: 2.34
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 21.51,
    cy: 38.62,
    r: 2.85
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 25.51,
    cy: 33.93,
    r: 2.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 21.35,
    cy: 30.94,
    r: 1.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 20.87,
    cy: 46.68,
    r: 1.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 28.98,
    cy: 38.67,
    r: 1.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 29.78,
    cy: 30.17,
    r: 1.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 12.98,
    cy: 29.86,
    r: 1.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 12.82,
    cy: 46.75,
    r: 1.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 29.78,
    cy: 46.91,
    r: 1.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 25.86,
    cy: 49.84,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 32.54,
    cy: 43.21,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 32.54,
    cy: 33.91,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 26.02,
    cy: 27.08,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 16.72,
    cy: 27.16,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 10.02,
    cy: 33.7,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 9.82,
    cy: 43.08,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 16.55,
    cy: 49.58,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 9.14,
    cy: 50.69,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 33.71,
    cy: 50.69,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 33.74,
    cy: 26.25,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 9.29,
    cy: 25.99,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 7.13,
    cy: 30.17,
    r: 0.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 6.26,
    cy: 22.74,
    r: 0.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 4.76,
    cy: 27.19,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 10.57,
    cy: 21.55,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 4.65,
    cy: 49.24,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 10.18,
    cy: 55.13,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 32.3,
    cy: 55.13,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 37.95,
    cy: 49.58,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 38.25,
    cy: 27.54,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 32.54,
    cy: 21.71,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 13.66,
    cy: 24.21,
    r: 0.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 13.5,
    cy: 24.21,
    r: 0.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 6.97,
    cy: 46.43,
    r: 0.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 13.24,
    cy: 52.58,
    r: 0.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 35.55,
    cy: 46.68,
    r: 0.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 29.62,
    cy: 24.21,
    r: 0.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 29.34,
    cy: 53,
    r: 0.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 5.88,
    cy: 53.88,
    r: 0.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 35.55,
    cy: 30.48,
    r: 0.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 36.8,
    cy: 53.88,
    r: 0.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 37.08,
    cy: 23.33,
    r: 0.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 13.24,
    cy: 38.67,
    r: 1.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 16.87,
    cy: 34.13,
    r: 2.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 16.55,
    cy: 42.63,
    r: 2.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 25.51,
    cy: 43.21,
    r: 2.34
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 53.04,
    y: 16.49,
    width: 0.86,
    height: 45.35
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M93.25,50.83c-.34-.32-.81-.48-1.41-.48h-2.12l-2.41,11.4h1.1l1.19-5.57h.73l.65,5.57h1.11l-.65-5.65c.48-.13.89-.38,1.24-.75.41-.44.71-1.04.87-1.79l.14-.63c.06-.3.08-.54.08-.73,0-.59-.18-1.06-.52-1.38ZM90.82,55.14h-1l.79-3.73h1.13c.66,0,.93.24.93.82,0,.15-.02.36-.07.62l-.12.59c-.13.58-.34,1.02-.62,1.3-.26.26-.61.39-1.05.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M99.03,50.35l-1.78,8.36c-.13.6-.26,1.05-.38,1.35-.1.26-.24.44-.43.56-.18.12-.46.18-.81.18-.45,0-.62-.09-.68-.14-.1-.09-.15-.25-.15-.48,0-.16.04-.52.21-1.32l1.8-8.51h-1.11l-1.78,8.39c-.14.65-.21,1.14-.21,1.48,0,.5.14.9.42,1.19.28.29.74.43,1.39.43s1.14-.14,1.51-.4c.37-.26.65-.62.82-1.04.16-.39.31-.91.45-1.54l1.8-8.51h-1.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "105.35 50.35 103.59 58.65 102.96 50.35 101.67 50.35 99.26 61.75 100.37 61.75 102.13 53.44 102.79 61.75 104.04 61.75 106.46 50.35 105.35 50.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M111.6,50.78c-.29-.29-.74-.43-1.38-.43h-2.06l-2.41,11.4h2.19c.63,0,1.15-.15,1.52-.44.37-.29.64-.66.82-1.11.16-.42.31-.96.46-1.65l1.05-4.91c.16-.76.24-1.3.24-1.65,0-.52-.14-.92-.43-1.21ZM108.8,60.51c-.19.12-.47.18-.84.18h-.87l1.96-9.28h1.08c.41,0,.58.08.64.13.03.02.13.14.13.55,0,.35-.06.83-.19,1.43l-1.03,4.88c-.14.67-.28,1.17-.42,1.5-.12.29-.28.49-.46.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M117.11,50.35l-1.78,8.36c-.13.6-.26,1.05-.38,1.35-.1.26-.24.44-.43.56-.18.12-.46.18-.81.18-.45,0-.62-.09-.68-.14-.1-.09-.15-.25-.15-.48,0-.16.04-.52.21-1.32l1.8-8.51h-1.11l-1.78,8.39c-.14.65-.21,1.14-.21,1.48,0,.5.14.9.42,1.19.28.29.74.43,1.39.43s1.14-.14,1.51-.4c.37-.26.65-.62.82-1.04.16-.39.31-.91.45-1.54l1.8-8.51h-1.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "120.86 58.99 121.18 50.35 119.76 50.35 117.35 61.75 118.45 61.75 119.96 54.66 119.7 61.75 120.9 61.75 123.59 54.81 122.12 61.75 123.22 61.75 125.63 50.35 124.2 50.35 120.86 58.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "133.49 50.35 129.95 59.37 130.23 50.35 129.12 50.35 128.83 61.75 130.15 61.75 134.65 50.35 133.49 50.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "136.43 51.41 139.15 51.41 139.38 50.35 135.55 50.35 133.14 61.75 136.97 61.75 137.19 60.69 134.47 60.69 135.43 56.18 137.75 56.18 137.98 55.12 135.65 55.12 136.43 51.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M144.55,52.2c0-.59-.18-1.06-.52-1.38-.34-.32-.81-.48-1.41-.48h-2.12l-2.41,11.4h1.1l1.19-5.57h.73l.65,5.57h1.11l-.65-5.65c.48-.13.89-.38,1.24-.75.41-.43.71-1.04.87-1.79l.14-.63c.06-.3.08-.54.08-.73ZM141.59,55.14h-1l.79-3.73h1.13c.66,0,.93.24.93.82,0,.15-.02.36-.07.62l-.12.59c-.13.58-.34,1.02-.62,1.3-.26.26-.61.39-1.05.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M148.92,53.92l1.07.1.07-.26c.2-.78.3-1.38.3-1.83,0-.55-.15-.97-.46-1.25-.3-.27-.75-.41-1.38-.41-.89,0-1.54.27-1.94.8-.36.49-.61,1.08-.76,1.77-.1.46-.15.88-.15,1.25,0,.89.3,1.56.88,1.99l.75.58c.2.17.37.36.49.58.11.2.17.49.17.84,0,.28-.03.55-.09.8-.14.67-.34,1.18-.57,1.51-.2.28-.54.42-1.03.42-.28,0-.48-.06-.59-.18-.12-.13-.17-.35-.17-.66,0-.4.06-.91.38-2.13l.08-.32-1.07-.2-.07.3c-.14.63-.25,1.14-.32,1.51-.07.39-.11.73-.11,1.03,0,.55.14.98.42,1.27.29.3.73.44,1.36.44s1.14-.15,1.52-.45c.37-.29.66-.65.84-1.06.17-.39.31-.86.42-1.39.08-.32.12-.65.12-.98,0-.92-.33-1.63-.97-2.11l-.75-.57c-.21-.16-.37-.34-.45-.52-.09-.19-.13-.42-.13-.69,0-.2.03-.51.1-.9.14-.66.33-1.15.56-1.46.2-.26.53-.39,1.01-.39.44,0,.62.1.68.16.11.1.16.27.16.51,0,.32-.05.72-.27,1.57l-.09.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M155.94,51.94c0-.51-.14-.92-.43-1.22-.29-.3-.75-.45-1.4-.45s-1.14.14-1.51.43c-.36.27-.64.64-.81,1.07-.16.4-.31.93-.45,1.57l-1.14,5.34c-.15.71-.22,1.2-.22,1.51,0,.51.14.92.42,1.21.29.3.74.44,1.39.44s1.14-.14,1.52-.42c.37-.27.65-.63.83-1.07.17-.4.32-.93.46-1.57l1.14-5.33c.14-.65.21-1.15.21-1.51ZM152.69,60.61h0c-.18.13-.45.19-.81.19-.43,0-.6-.09-.66-.15-.1-.09-.15-.26-.15-.51s.07-.71.21-1.37l1.14-5.31c.13-.6.26-1.06.38-1.37.11-.27.25-.47.43-.59.18-.13.45-.19.81-.19.44,0,.6.09.66.15.12.11.15.34.15.51,0,.29-.07.75-.19,1.37l-1.14,5.3c-.13.6-.26,1.07-.38,1.38-.11.27-.26.47-.44.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M161.88,52.2c0-.59-.18-1.06-.52-1.38-.34-.32-.81-.48-1.41-.48h-2.12l-2.41,11.4h1.1l1.19-5.57h.73l.65,5.57h1.11l-.65-5.65c.48-.13.89-.38,1.24-.75.41-.43.71-1.04.87-1.79l.14-.63c.06-.3.08-.54.08-.73ZM158.92,55.14h-1l.79-3.73h1.13c.66,0,.93.24.93.82,0,.15-.02.36-.07.62l-.12.59c-.13.58-.34,1.02-.62,1.3-.26.26-.61.39-1.05.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M165.83,50.27c-.63,0-1.14.14-1.51.42-.36.27-.64.62-.81,1.05-.16.39-.31.91-.45,1.55l-1.15,5.42c-.14.65-.21,1.14-.21,1.5,0,.5.14.9.42,1.19.29.3.74.44,1.39.44.49,0,1.99,0,2.36-1.39l.98-4.14.12-.62h-2.59l-.23,1.06h1.49l-.46,2.1c-.11.52-.23.93-.36,1.21-.11.25-.26.44-.45.56-.18.12-.45.18-.78.18-.43,0-.6-.09-.66-.15-.1-.09-.15-.26-.15-.49,0-.17.04-.53.21-1.34l1.2-5.65c.11-.51.23-.9.35-1.18.11-.24.25-.41.44-.52.19-.11.44-.16.76-.16.41,0,.58.09.66.16.11.1.16.28.16.53,0,.21-.05.69-.31,1.76l-.1.39h1.14s.06-.25.06-.25c.18-.71.3-1.48.3-1.97,0-.53-.15-.94-.44-1.23s-.75-.44-1.4-.44Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "168.71 50.35 168.49 51.41 170.21 51.41 168.03 61.75 169.13 61.75 171.32 51.41 173.03 51.41 173.25 50.35 168.71 50.35"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M93.25,50.83c-.34-.32-.81-.48-1.41-.48h-2.12l-2.41,11.4h1.1l1.19-5.57h.73l.65,5.57h1.11l-.65-5.65c.48-.13.89-.38,1.24-.75.41-.44.71-1.04.87-1.79l.14-.63c.06-.3.08-.54.08-.73,0-.59-.18-1.06-.52-1.38ZM90.82,55.14h-1l.79-3.73h1.13c.66,0,.93.24.93.82,0,.15-.02.36-.07.62l-.12.59c-.13.58-.34,1.02-.62,1.3-.26.26-.61.39-1.05.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M99.03,50.35l-1.78,8.36c-.13.6-.26,1.05-.38,1.35-.1.26-.24.44-.43.56-.18.12-.46.18-.81.18-.45,0-.62-.09-.68-.14-.1-.09-.15-.25-.15-.48,0-.16.04-.52.21-1.32l1.8-8.51h-1.11l-1.78,8.39c-.14.65-.21,1.14-.21,1.48,0,.5.14.9.42,1.19.28.29.74.43,1.39.43s1.14-.14,1.51-.4c.37-.26.65-.62.82-1.04.16-.39.31-.91.45-1.54l1.8-8.51h-1.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "105.35 50.35 103.59 58.65 102.96 50.35 101.67 50.35 99.26 61.75 100.37 61.75 102.13 53.44 102.79 61.75 104.04 61.75 106.46 50.35 105.35 50.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M111.6,50.78c-.29-.29-.74-.43-1.38-.43h-2.06l-2.41,11.4h2.19c.63,0,1.15-.15,1.52-.44.37-.29.64-.66.82-1.11.16-.42.31-.96.46-1.65l1.05-4.91c.16-.76.24-1.3.24-1.65,0-.52-.14-.92-.43-1.21ZM108.8,60.51c-.19.12-.47.18-.84.18h-.87l1.96-9.28h1.08c.41,0,.58.08.64.13.03.02.13.14.13.55,0,.35-.06.83-.19,1.43l-1.03,4.88c-.14.67-.28,1.17-.42,1.5-.12.29-.28.49-.46.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M117.11,50.35l-1.78,8.36c-.13.6-.26,1.05-.38,1.35-.1.26-.24.44-.43.56-.18.12-.46.18-.81.18-.45,0-.62-.09-.68-.14-.1-.09-.15-.25-.15-.48,0-.16.04-.52.21-1.32l1.8-8.51h-1.11l-1.78,8.39c-.14.65-.21,1.14-.21,1.48,0,.5.14.9.42,1.19.28.29.74.43,1.39.43s1.14-.14,1.51-.4c.37-.26.65-.62.82-1.04.16-.39.31-.91.45-1.54l1.8-8.51h-1.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "120.86 58.99 121.18 50.35 119.76 50.35 117.35 61.75 118.45 61.75 119.96 54.66 119.7 61.75 120.9 61.75 123.59 54.81 122.12 61.75 123.22 61.75 125.63 50.35 124.2 50.35 120.86 58.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "133.49 50.35 129.95 59.37 130.23 50.35 129.12 50.35 128.83 61.75 130.15 61.75 134.65 50.35 133.49 50.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "136.43 51.41 139.15 51.41 139.38 50.35 135.55 50.35 133.14 61.75 136.97 61.75 137.19 60.69 134.47 60.69 135.43 56.18 137.75 56.18 137.98 55.12 135.65 55.12 136.43 51.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M144.55,52.2c0-.59-.18-1.06-.52-1.38-.34-.32-.81-.48-1.41-.48h-2.12l-2.41,11.4h1.1l1.19-5.57h.73l.65,5.57h1.11l-.65-5.65c.48-.13.89-.38,1.24-.75.41-.43.71-1.04.87-1.79l.14-.63c.06-.3.08-.54.08-.73ZM141.59,55.14h-1l.79-3.73h1.13c.66,0,.93.24.93.82,0,.15-.02.36-.07.62l-.12.59c-.13.58-.34,1.02-.62,1.3-.26.26-.61.39-1.05.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M148.92,53.92l1.07.1.07-.26c.2-.78.3-1.38.3-1.83,0-.55-.15-.97-.46-1.25-.3-.27-.75-.41-1.38-.41-.89,0-1.54.27-1.94.8-.36.49-.61,1.08-.76,1.77-.1.46-.15.88-.15,1.25,0,.89.3,1.56.88,1.99l.75.58c.2.17.37.36.49.58.11.2.17.49.17.84,0,.28-.03.55-.09.8-.14.67-.34,1.18-.57,1.51-.2.28-.54.42-1.03.42-.28,0-.48-.06-.59-.18-.12-.13-.17-.35-.17-.66,0-.4.06-.91.38-2.13l.08-.32-1.07-.2-.07.3c-.14.63-.25,1.14-.32,1.51-.07.39-.11.73-.11,1.03,0,.55.14.98.42,1.27.29.3.73.44,1.36.44s1.14-.15,1.52-.45c.37-.29.66-.65.84-1.06.17-.39.31-.86.42-1.39.08-.32.12-.65.12-.98,0-.92-.33-1.63-.97-2.11l-.75-.57c-.21-.16-.37-.34-.45-.52-.09-.19-.13-.42-.13-.69,0-.2.03-.51.1-.9.14-.66.33-1.15.56-1.46.2-.26.53-.39,1.01-.39.44,0,.62.1.68.16.11.1.16.27.16.51,0,.32-.05.72-.27,1.57l-.09.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M155.94,51.94c0-.51-.14-.92-.43-1.22-.29-.3-.75-.45-1.4-.45s-1.14.14-1.51.43c-.36.27-.64.64-.81,1.07-.16.4-.31.93-.45,1.57l-1.14,5.34c-.15.71-.22,1.2-.22,1.51,0,.51.14.92.42,1.21.29.3.74.44,1.39.44s1.14-.14,1.52-.42c.37-.27.65-.63.83-1.07.17-.4.32-.93.46-1.57l1.14-5.33c.14-.65.21-1.15.21-1.51ZM152.69,60.61h0c-.18.13-.45.19-.81.19-.43,0-.6-.09-.66-.15-.1-.09-.15-.26-.15-.51s.07-.71.21-1.37l1.14-5.31c.13-.6.26-1.06.38-1.37.11-.27.25-.47.43-.59.18-.13.45-.19.81-.19.44,0,.6.09.66.15.12.11.15.34.15.51,0,.29-.07.75-.19,1.37l-1.14,5.3c-.13.6-.26,1.07-.38,1.38-.11.27-.26.47-.44.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M161.88,52.2c0-.59-.18-1.06-.52-1.38-.34-.32-.81-.48-1.41-.48h-2.12l-2.41,11.4h1.1l1.19-5.57h.73l.65,5.57h1.11l-.65-5.65c.48-.13.89-.38,1.24-.75.41-.43.71-1.04.87-1.79l.14-.63c.06-.3.08-.54.08-.73ZM158.92,55.14h-1l.79-3.73h1.13c.66,0,.93.24.93.82,0,.15-.02.36-.07.62l-.12.59c-.13.58-.34,1.02-.62,1.3-.26.26-.61.39-1.05.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M165.83,50.27c-.63,0-1.14.14-1.51.42-.36.27-.64.62-.81,1.05-.16.39-.31.91-.45,1.55l-1.15,5.42c-.14.65-.21,1.14-.21,1.5,0,.5.14.9.42,1.19.29.3.74.44,1.39.44.49,0,1.99,0,2.36-1.39l.98-4.14.12-.62h-2.59l-.23,1.06h1.49l-.46,2.1c-.11.52-.23.93-.36,1.21-.11.25-.26.44-.45.56-.18.12-.45.18-.78.18-.43,0-.6-.09-.66-.15-.1-.09-.15-.26-.15-.49,0-.17.04-.53.21-1.34l1.2-5.65c.11-.51.23-.9.35-1.18.11-.24.25-.41.44-.52.19-.11.44-.16.76-.16.41,0,.58.09.66.16.11.1.16.28.16.53,0,.21-.05.69-.31,1.76l-.1.39h1.14s.06-.25.06-.25c.18-.71.3-1.48.3-1.97,0-.53-.15-.94-.44-1.23s-.75-.44-1.4-.44Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "168.71 50.35 168.49 51.41 170.21 51.41 168.03 61.75 169.13 61.75 171.32 51.41 173.03 51.41 173.25 50.35 168.71 50.35"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70.7,28.46l-1.5-1.14c-.42-.32-.71-.66-.88-1.01-.17-.36-.26-.82-.26-1.34,0-.39.07-.99.2-1.8.28-1.3.65-2.26,1.1-2.86.37-.5,1.01-.74,1.95-.74.86,0,1.19.18,1.3.29.19.18.29.5.29.97,0,.6-.2,1.39-.61,2.96l-.26.99,2.42.18.15-.57c.41-1.57.61-2.77.61-3.68,0-1.12-.32-1.98-.94-2.55-.61-.56-1.53-.83-2.81-.83-1.81,0-3.13.55-3.93,1.64-.72.98-1.24,2.18-1.52,3.56-.19.93-.29,1.77-.29,2.51,0,1.8.6,3.16,1.79,4.04l1.49,1.16c.4.33.71.71.94,1.13.22.39.33.95.33,1.64,0,.56-.06,1.08-.17,1.57-.29,1.33-.66,2.33-1.13,2.98-.38.54-1.04.8-1.99.8-.54,0-.92-.11-1.12-.33-.21-.24-.33-.68-.33-1.26,0-.88.29-2.46.87-4.71l.21-.81-2.48-.21-.13.62c-.24,1.17-.42,2.19-.55,2.93l-.08.46c-.14.77-.21,1.47-.21,2.06,0,1.13.29,2,.86,2.59.59.61,1.49.91,2.77.91s2.3-.31,3.09-.92c.76-.58,1.33-1.31,1.69-2.16.33-.77.62-1.71.85-2.8.15-.64.23-1.31.23-1.97,0-1.87-.66-3.31-1.97-4.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M85.25,23.99l.28-1.23v-.03c.12-.6.17-1.09.17-1.48,0-1.2-.36-2.15-1.07-2.81-.7-.65-1.66-.97-2.86-.97h-4.29l-4.85,22.93h2.37l2.37-11.12h2.19c1.41,0,2.64-.47,3.66-1.4,1-.91,1.69-2.22,2.04-3.89ZM79.7,27.03h-1.89l1.54-7.28h2.19c1.57,0,1.78.75,1.78,1.57,0,.3-.05.71-.14,1.22l-.24,1.18c-.26,1.15-.66,2.01-1.21,2.56-.51.51-1.18.76-2.03.76Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "88.01 17.47 83.16 40.4 85.53 40.4 90.38 17.47 88.01 17.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "100.83 17.47 91.61 17.47 91.12 19.75 94.57 19.75 90.2 40.4 92.57 40.4 96.94 19.75 100.35 19.75 100.83 17.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "101.72 29.27 106.36 29.27 106.84 27 102.2 27 103.71 19.75 109.15 19.75 109.64 17.47 101.83 17.47 96.98 40.4 104.79 40.4 105.28 38.12 99.83 38.12 101.72 29.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "118.36 17.47 114.16 25.29 113.27 17.47 110.82 17.47 112.15 28.34 105.64 40.4 108.23 40.4 112.85 31.8 113.88 40.4 116.29 40.4 114.84 28.65 120.99 17.47 118.36 17.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "135.59 17.47 129.07 34.34 129.71 17.47 126.71 17.47 121.86 40.4 124.23 40.4 127.06 27.07 126.58 40.4 129.12 40.4 134.14 27.41 131.39 40.4 133.76 40.4 138.61 17.47 135.59 17.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M148.46,20.73c0-1.04-.29-1.88-.87-2.49-.6-.62-1.53-.93-2.85-.93s-2.31.29-3.07.87c-.74.56-1.29,1.29-1.64,2.18-.32.8-.62,1.86-.9,3.14l-2.27,10.66c-.3,1.41-.45,2.4-.45,3.04,0,1.05.29,1.88.86,2.47.59.61,1.51.91,2.83.91s2.31-.29,3.08-.86c.75-.56,1.31-1.29,1.68-2.17.33-.81.64-1.86.91-3.15l2.27-10.63c.28-1.31.41-2.3.41-3.04ZM141.85,37.97h0c-.35.24-.87.37-1.56.37-.83,0-1.15-.17-1.26-.28-.23-.21-.28-.63-.28-.95,0-.35.07-1.1.41-2.71l2.27-10.6c.26-1.19.51-2.1.75-2.72.21-.53.48-.9.84-1.15.35-.24.87-.36,1.56-.36.88,0,1.18.19,1.27.27.22.21.27.64.27.96,0,.58-.13,1.5-.38,2.71l-2.27,10.57c-.26,1.2-.51,2.12-.76,2.74-.21.52-.5.91-.85,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M156.2,28.6c-.07-.1-.15-.19-.23-.27.37-.28.7-.66.97-1.12.51-.86.92-1.97,1.22-3.32l.21-1.01c.15-.7.23-1.36.23-1.96,0-1.33-.37-2.26-1.1-2.76-.65-.45-1.49-.68-2.49-.68h-3.95l-4.85,22.93h4.47c1.07,0,1.96-.18,2.65-.52.73-.36,1.33-1,1.8-1.89.43-.82.8-1.94,1.13-3.4l.31-1.64c.15-.76.23-1.47.23-2.11,0-.99-.19-1.72-.59-2.24ZM150.91,29.4h1.52c.98,0,1.42.2,1.62.36.31.26.37.81.37,1.24,0,.48-.1,1.25-.29,2.25l-.22,1.04c-.27,1.31-.57,2.26-.89,2.82-.36.62-.63.79-.76.84-.32.12-.79.17-1.4.17h-1.8l1.85-8.72ZM154.79,19.75c.72,0,1.04.15,1.19.28.23.21.28.66.28,1.01,0,.43-.07.92-.2,1.46l-.25,1.19c-.19.91-.41,1.63-.63,2.13-.19.43-.45.75-.78.98-.32.22-.79.32-1.4.32h-1.62l1.55-7.37h1.85Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "161.54 17.47 156.69 40.4 159.06 40.4 163.91 17.47 161.54 17.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "168.15 17.47 165.78 17.47 160.93 40.4 168.74 40.4 169.22 38.12 163.78 38.12 168.15 17.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "174.63 17.47 169.78 40.4 172.15 40.4 177 17.47 174.63 17.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "194.79 17.47 190.33 26.64 189.75 17.47 187.35 17.47 187.34 17.47 178.12 17.47 177.64 19.75 181.08 19.75 176.72 40.4 179.09 40.4 183.45 19.75 186.86 19.75 187.34 17.5 188.28 30.73 186.24 40.4 188.61 40.4 190.59 31.02 197.39 17.47 194.79 17.47"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpitex);
export default __webpack_public_path__ + "static/media/spitex.b3c54520195fdeb78cae4fd62b937ca2.svg";
export { ForwardRef as ReactComponent };